// extracted by mini-css-extract-plugin
module.exports = {"value":"ClaimNumberLabel_value__gzfqw","label":"ClaimNumberLabel_label__plpWR"};